// extracted by mini-css-extract-plugin
export default {"panel":"Alergoide_panel__PwjgO","subHeader":"Alergoide_subHeader__bjQ76","sectionHeader":"Alergoide_sectionHeader__BX+md"};